module.exports = __webpack_public_path__ + "img/live-drop-cf5a63a9314210d55fe7d17bbacc122a.8ba18bce.png";